import { useQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import {
    FlexColumnCenter,
    FormCircularProgress, IconButton, Input, toasty,
} from '../../common/forms/FormElements';

export const PasswordResetModal = ({ applicationUserId }) => {
    const { data, isLoading } = useQuery({
        queryKey: ['passwordLink', applicationUserId],
        queryFn: () => httpClient.js(ApiRoutes.locationContact.getPasswordLink(applicationUserId)),
    });

    if (isLoading) {
        return (
            <FlexColumnCenter className="align-items-center p-4">
                <FormCircularProgress />

                <span className="h5 mt-3">Loading user data...</span>
            </FlexColumnCenter>
        );
    }

    return (
        <>
            <p>
                You can copy the below password reset link and send it to the contact if they are unable to log in to the customer portal.
            </p>

            <Input
                name="passwordLink"
                value={data}
                endAddon={(
                    <IconButton
                        onClick={() => {
                            navigator.clipboard.writeText(data)
                                .then(() => toasty.success('Copied url to clipboard'))
                                .catch(() => toasty.error('Failed to copy url'));
                        }}
                    >
                        <FontAwesomeIcon icon={faClipboard} />
                    </IconButton>
                )}
            />
        </>
    );
};